import { Provider } from 'mobx-react';
import React from 'react';
import RootStore from '../stores/RootStore';
import { mergeGravityFormState } from './GravityFormStateMergeUtil';
import NoticeRootStore from '../stores/NoticeRootStore';
let rootStore;
let noticeRootStore;
const StoresProvider = (props) => {
    const { children, ...rest } = props;
    if (rootStore === undefined) {
        rootStore = new RootStore(rest);
    }
    else {
        React.useEffect(() => {
            mergeGravityFormState(rootStore, rest);
        });
    }
    return (React.createElement(Provider, { ...rootStore },
        React.createElement(Provider, { ...noticeRootStore }, children)));
};
const NoticeStoresProvider = (props) => {
    const { children, ...rest } = props;
    if (noticeRootStore === undefined) {
        noticeRootStore = new NoticeRootStore(rest);
    }
    return React.createElement(Provider, { ...noticeRootStore }, children);
};
export const withStores = (Component) => {
    return function WrappedComponent(props) {
        const { language, env, decodedParams, navigate, clientAuth, pathname, hasProvider, cmsData, credentialsAllowed, formsList, app } = props;
        if (hasProvider) {
            return React.createElement(Component, { ...props });
        }
        return (React.createElement(StoresProvider, { language, env, decodedParams, navigate, clientAuth, pathname, cmsData, credentialsAllowed, formsList, app },
            React.createElement(Component, { ...props })));
    };
};
export const noticeWithStores = (Component) => {
    return function WrappedComponent(props) {
        const { language, env } = props;
        return (React.createElement(NoticeStoresProvider, { language, env },
            React.createElement(Component, { ...props })));
    };
};
//# sourceMappingURL=StoresProvider.js.map